import { render } from "./ModalConsultationInfo.vue?vue&type=template&id=3e32f01d"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__